/**
 * @generated SignedSource<<2670079b3ef5182f148399fbe8b7f992>>
 * @relayHash fde261065032c7ce682a15429d316dd1
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/557.0.0-2026-04-29T16:01:43.567Z/pdpSharedNotificationMultiplePdpVisitsModalConfigQuery

import { ConcreteRequest } from 'relay-runtime';
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQuery$variables = {
  itemIds: ReadonlyArray<string | null>;
};
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQuery$data = {
  readonly viewer: {
    readonly itemRead: ReadonlyArray<{
      readonly isPrivateVisibilityType?: boolean | null;
      readonly pricing?: {
        readonly bargain: boolean | null;
      } | null;
      readonly status?: string | null;
    } | null> | null;
  };
};
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQuery = {
  response: pdpSharedNotificationMultiplePdpVisitsModalConfigQuery$data;
  variables: pdpSharedNotificationMultiplePdpVisitsModalConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivateVisibilityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPricing",
      "kind": "LinkedField",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bargain",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/557.0.0-2026-04-29T16:01:43.567Z/pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "metadata": {},
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "65c36a50087ae7f9205d2ecece186a37";

export default node;
